import { useEffect } from 'react'

/**
 * Signals to the SEO prerenderer (scripts/prerender.js) that the page has
 * finished its initial render and is safe to capture.
 *
 * Call this once in any public page that should be prerendered. The hook
 * injects a `<meta name="prerender-ready">` marker, which the headless
 * Chromium poll-loop in prerender.js waits for before snapshotting the HTML.
 *
 * In dev/preview the marker is harmless (just an extra meta tag).
 */
export function usePrerenderReady() {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (typeof document === 'undefined') return
      if (document.querySelector('meta[name="prerender-ready"]')) return
      const marker = document.createElement('meta')
      marker.setAttribute('name', 'prerender-ready')
      marker.setAttribute('content', 'true')
      document.head.appendChild(marker)
    }, 100)
    return () => clearTimeout(timer)
  }, [])
}

export default usePrerenderReady
